export default "__VITE_ASSET__CjVBXpEp__"